import React, {PureComponent} from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {Label1} from "@irati/ui/src/Labels"
import padding from "@irati/ui/src/global/padding"

const EmptySection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`

const EmptyText = styled(Label1)`
  padding-bottom: ${padding.small};
`

class CompanyValuesEmpty extends PureComponent {
  render() {
    return (
      <EmptySection>
        <EmptyText bold={false} uppercase={false}>
          <FormattedMessage id="admin.companyValues.list.empty" />
        </EmptyText>
      </EmptySection>
    )
  }
}
export default CompanyValuesEmpty
